import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row;
  background-color: #ffffff;
  @media (max-width: 770px) {
    height: 100vh;
    overflow-y: hidden;
    padding: 0;
  }
`;

export const HeaderContainer = styled.div`
  width: 100%;
  padding: 0 0 20px 20px;
  background-color: white;

  @media (max-width: 770px) {
    display: none;
    padding: 0;
  }
`;

export const HeaderMobileContainer = styled.div`
  @media (min-width: 770px) {
    display: none;
  }
`;

export const SideBarContainer = styled.div`
  height: 100vh;
  min-width: 150px;
  background-image: linear-gradient(rgb(51, 139, 251), rgb(165, 64, 227));
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  display: flex;
  @media (max-width: 770px) {
    background-image: linear-gradient(rgb(165, 64, 227), rgb(165, 64, 227));
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 15vh;
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
    border-top-right-radius: 0px;
  }
`;

export const Content = styled.div`
  width: 100%;
  height: 100vh;
  background-color: #ffffff;

  @media (max-width: 770px) {
    width: 100%;
    height: 98vh;
  }
`;

export const NavigationContainer = styled.div`
  width: 100%;
  height: 80vh;
  padding: 0px 65px;
  overflow-y: scroll;
  margin: 0 auto;

  @media(min-width: 770px) {
    width: 100%;
    height: ${(props) => {
      const roles = [];
      ["BOLETOS", "NOTAS_FISCAIS", "VALE_GAS", "CONTRATOS"].map((element) => {
        if(props.verifyRoles(props.roles, element)) {
          roles.push(element)
        }
        return roles;
      })
      if(roles.length < 2) {
        return "40vh"
      } else if (roles.length === 2) {
        return "65vh"
      } else {
        return "70vh"
      }
    }};
  }

  @media(min-width: 770px) and (max-height: 670px) {
    height: 60vh !important;
  }

  @media(min-width: 770px) and (max-height: 650px) {
    height: 70vh !important;
  }

  @media(min-width: 770px) and (max-width: 1400px) {
    width: 100%;
    height: ${(props) => {
      const roles = [];
      ["BOLETOS", "NOTAS_FISCAIS", "VALE_GAS", "CONTRATOS"].map((element) => {
        if(props.verifyRoles(props.roles, element)) {
          roles.push(element)
        }
        return ""
      })
      if(roles.length < 2) {
        return "40vh"
      } else if (roles.length === 2) {
        return "65vh"
      } else {
        return "70vh"
      }
    }};
  }

  @media (max-width: 770px) {
    width: 100%;
    padding: 30px 5px;
    background-color: #ffffff;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }
`;

export const PageContainer = styled.div`
  height: 100%;
  width: 100%;
  background-color: #ffffff;
`;

export const DivisionCards = styled.div`
  @media(min-width: 770px) {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin: 5rem 0 0 0;
  }

  @media(max-width: 770px) {
    display: none;
  }
`;

export const DivisionCardsMobile = styled.div`
  @media(min-width: 770px) {
    display: none;
  }

  @media(max-width: 770px) {
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-direction: column;
    margin: 0;
  }
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  margin: 4rem 0 2rem 5rem;

  @media (max-width: 1000px) {
    width: 100%;
  }
  @media (max-width: 768px) {
    margin-left: 30px;
  }
`;

export const ValeIcon = styled.img`
  width: 39px;
  height: 26px;
  margin-right: 20px;
`;

export const PageTitle = styled.span`
  color: #808080;
  font-size: 20px;
  font-weight: 300;
`;

export const BackIcon = styled.span`
  display: flex;
  justify-content: flex-end;
  margin: -2rem 5rem 1.5rem 0;
  cursor: pointer;

  @media (max-width: 1366px) {
    margin: 0 5rem 0 0;
  }

  @media (max-width: 770px) {
    margin: -2rem 1rem 0.3rem 0;
  }
`;